"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TIME_VALIDATION_REGEX = void 0;
exports.TIME_VALIDATION_REGEX = /^([0-1][0-9]|2[0-3]):[0-5][0-9]$/;
